const copy = {
  messages: {
    endUserAlias: "You",
    eventLabel: (displayName: string, date: string): string =>
      `said by ${displayName} on ${date}`,
    startBookend: "Conversation started",
    timeStamp: (displayName: string, timeStamp: string): string =>
      `${displayName} ・ ${timeStamp}`,
    retryText: "Message failed",
  },
  loadingTitle: "Loading conversations",
};

export default copy;
